/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/11
 */
import request from 'crm/utils/request'
import api from 'crm/common/api/companies'

export async function info() {
    return request(`${api.info.url}`)
}

export async function update(payload) {
    return request(api.update.url, {
        method: api.update.type,
        body: payload.body,
    })
}

export async function secret() {
    return request(api.secret.url)
}
